<nav aria-label="breadcrumb" class="p-4 bg-gray-100 overflow-x-auto">
    <ol class="max-w-7xl mx-auto flex space-x-4 text-gray-400 text-xs sm:text-sm font-medium">
        <li class="breadcrumb-item hover:text-gray-500">
            <a [routerLink]="['/']">Home</a>
        </li>
        <li
            class="breadcrumb-item hover:text-gray-600 whitespace-nowrap"
            *ngFor="let breadcrumb of breadcrumbLinks(); last as isLast; first as isFirst"
            [ngClass]="{ 'text-gray-700': isLast }"
            [attr.aria-current]="isLast"
        >
            <ng-container *ngIf="isLast && !linkLast; else link">{{ breadcrumb.name }}</ng-container>
            <ng-template #link>
                <a [routerLink]="[breadcrumb.url]">{{ breadcrumb.name }}</a>
            </ng-template>
        </li>
    </ol>
</nav>
<kb-json-ld [json]='jsonLdData()'></kb-json-ld>
